import { render, staticRenderFns } from "./EmployeeRfcInfo.vue?vue&type=template&id=5023fc23"
import script from "./EmployeeRfcInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeRfcInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports